import state from "../state";
import * as Utils from "../utils/utils.js";
import PlayerPaths from "../constants/paths/playerPaths.js";
import _ from "lodash";

class RuntimeApi {

	setGlobalVar(name, value) {
		state.set(PlayerPaths.GLOBAL_VARS(name), value);
	}

	getGlobalVar(name) {
		return state.get(PlayerPaths.GLOBAL_VARS(name));
	}

	findCurrentList() {
		let selectedListIndex = state.get(PlayerPaths.ACTIVITY_PROPERTY("listIndex"));

		return {
			node: state.get(PlayerPaths.ACTIVITY_LIST(selectedListIndex)),
			path: PlayerPaths.ACTIVITY_LIST(selectedListIndex)
		};
	}

	findCurrentSection() {
		let selectedListIndex = state.get(PlayerPaths.ACTIVITY_PROPERTY("listIndex"));
		let selectedSectionIndex = state.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);

		return {
			node: state.get(PlayerPaths.ACTIVITY_SECTION(selectedListIndex, selectedSectionIndex)),
			path: PlayerPaths.ACTIVITY_SECTION(selectedListIndex, selectedSectionIndex)
		};
	}

	findCurrentItem() {
		let selectedListIndex = state.get(PlayerPaths.ACTIVITY_PROPERTY("listIndex"));
		let selectedSectionIndex = state.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
		let selectedItemIndex = state.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

		return {
			node: state.get(PlayerPaths.ACTIVITY_ITEM(selectedListIndex, selectedSectionIndex, selectedItemIndex)),
			path: PlayerPaths.ACTIVITY_ITEM(selectedListIndex, selectedSectionIndex, selectedItemIndex)
		};
	}

	findListById(id=null) {
		if (_.isUndefined(id) || id === null) {
			return this.findCurrentList();
		} else {
			let nodeIndex = state.get(["idMap", id]);
			if (nodeIndex) {
				return {
					node: state.get(PlayerPaths.ACTIVITY_SECTION(nodeIndex.listIndex)),
					path: PlayerPaths.ACTIVITY_SECTION(nodeIndex.listIndex)
				}; 
			}
		}

		return {node: null, path: []};
	}

	findSectionById(id=null) {
		if (_.isUndefined(id) || id === null) {
			return this.findCurrentSection();
		} else {
			let nodeIndex = state.get(["idMap", id]);
			if (nodeIndex) {
				return {
					node: state.get(PlayerPaths.ACTIVITY_SECTION(nodeIndex.listIndex, nodeIndex.sectionIndex)),					
					path: PlayerPaths.ACTIVITY_SECTION(nodeIndex.listIndex, nodeIndex.sectionIndex)
				};
			}
		}

		return { node: null, path: [] };
	}

	findItemById(id=null) {
		if (_.isUndefined(id) || id === null) {
			return this.findCurrentItem();
		} else {
			let nodeIndex = state.get(["idMap", id]);
			if (nodeIndex) {
				return {
					node: state.get(PlayerPaths.ACTIVITY_ITEM(nodeIndex.listIndex, nodeIndex.sectionIndex, nodeIndex.itemIndex)),
					path: PlayerPaths.ACTIVITY_ITEM(nodeIndex.listIndex, nodeIndex.sectionIndex, nodeIndex.itemIndex)
				};
			}
		}

		return { node: null, path: [] };
	}

	findNodeById(id=null) {
		if (_.isUndefined(id) || id === null) {
			return this.findCurrentItem();
		} else {
			Utils.findNodeById(state, id);
			return Utils.getLastFoundNode();
		}
	}

	isChecked(id) {
		const {node} = this.findItemById(id);

		if (node) {
			return node.checked;
		} else {
			return null;
		}
	}

	getValue(id) {
		const { node } = this.findItemById(id);

		if (node) {
			return node.value;
		} else {
			return null;
		}
	}

	getLists() {
		return state.get(PlayerPaths.ACTIVITY_LISTS);
	}

	getSections(listId) {
		const { node } = this.findListById(listId);

		return node.children;
	}

	getItems(sectionId) {
		const { node } = this.findSectionById(sectionId);

		return node.children;
	}

	setVisible(id, visible = true) {
		const { node, path } = this.findNodeById(id);
		
		if (node) {
			//node.visible = visible;	
			state.set(_.concat(path, "visible"), visible);
			// Need to refresh entire screen if change section
			// if (node.type === "section") {
			// 	this.forceRefresh();
			// }
		}

	}

	setHidden(id) {
		this.setVisible(id,false);
	}

	setGroupVisible(groupName) {
		let group = state.get(["groups", groupName]);

		//var foundSection = false;

		for (let i = 0; i < group.length; i++) {
			Utils.findNodeByGuid(state, group[i].guid);
			const { node, path } = Utils.getLastFoundNode();
			
			if (node) {
				state.set(_.concat(path, "visible"), true);
			}
			//node.visible = true;

			// if (node.type === "section") {
			// 	foundSection = true;
			// }
		}
		// if (foundSection) {
		// 	this.forceRefresh();
		// }
	}

	setGroupHidden(groupName) {
		let group = state.get(["groups", groupName]);

		for (let i = 0; i < group.length; i++) {
			Utils.findNodeByGuid(state, group[i].guid);
			const { node, path } = Utils.getLastFoundNode();

			if (node) {
				state.set(_.concat(path, "visible"), false);
			}
		}
	}
	/*
	setEnabled(id, enabled=true) {
		var node = this.findNodeById(id);
		
		if (node) {
			node.enabled = enabled;	
			// Need to refresh entire screen if change section
			if (node.type === "section") {
				this.forceRefresh();
			}
		}

	}

	setDisabled(id) {
		this.setEnabled(id,false);
	}

	setListTitle(id, title) {
		var node = this.findListById(id);
		
		if (node) {
			if (node.hasOwnProperty("title")) {
				node.title = title;	
			}
		}
	}

	setSectionTitle(id, title) {
		var node = this.findSectionById(id);
		
		if (node) {
			if (node.hasOwnProperty("section")) {
				node.title = title;	
			}
		}
	}

	setItemLabel1(id, label) {
		var node = this.findItemById(id);
		
		if (node) {
			if (node.hasOwnProperty("label1")) {
				node.label1 = label;	
			}
		}
	}

	setItemLabel2(id, label) {
		var node = this.findItemById(id);
		
		if (node) {
			if (node.hasOwnProperty("label2")) {
				node.label2 = label;	
			}
		}
	}
*/
	forceRefresh() {
		state.set(["session"], state.get(["session"]) + 1);
	}
}

export default new RuntimeApi();